export default __webpack_public_path__ + "static/media/233.108c15e9.jpg";